export const EULA_EN = {
  title: "End User License Agreement",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "This End User License Agreement (the \"License\") governs your use of the HELCOO app on iOS, iPadOS and Android. The License is concluded between you and HELCOO (the \"Licensor\") only, and not with Apple Inc. or Google LLC. Contact: support@helcoo.uk.",
  sections: [
    {
      h: "1. Scope of licence",
      p: [
        "Licensor grants you a personal, non-transferable, non-exclusive, revocable licence to use the app on any device that you own or control, as permitted by the Usage Rules of the applicable store's terms of service.",
        "The licence is conditional on your company holding an active subscription to the service, and the app is to be used for business purposes only.",
        "You may not distribute, rent, lease, sell or sublicense the app, nor modify, reverse engineer or extract its source code, except to the extent expressly permitted by law.",
      ],
    },
    {
      h: "2. Maintenance and support",
      p: [
        "Licensor is solely responsible for providing any maintenance and support services for the app. Neither Apple nor Google has any obligation whatsoever to furnish any maintenance or support services.",
        "Official support channel: support@helcoo.uk, with a target response time of two business days.",
      ],
    },
    {
      h: "3. Warranty",
      p: [
        "Licensor is solely responsible for any product warranties, whether express or implied, that have not been effectively disclaimed.",
        "In the event of any failure of the app to conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price, if any (the app is free to download). To the maximum extent permitted by law, Apple will have no other warranty obligation whatsoever with respect to the app, and any other claims, losses, liabilities, damages, costs or expenses attributable to a failure to conform to any warranty are the sole responsibility of Licensor.",
      ],
    },
    {
      h: "4. Product claims",
      p: [
        "Licensor, and not Apple or Google, is responsible for addressing any claims by you or any third party relating to the app or your possession and/or use of it, including: product liability claims; any claim that the app fails to conform to any applicable legal or regulatory requirement; and claims arising under consumer protection, privacy or similar legislation, including in connection with the app's use of biometric verification frameworks.",
      ],
    },
    {
      h: "5. Intellectual property rights",
      p: [
        "In the event of any third-party claim that the app or your possession and use of it infringes that third party's intellectual property rights, Licensor, and not Apple or Google, is solely responsible for the investigation, defence, settlement and discharge of that claim.",
      ],
    },
    {
      h: "6. Legal compliance",
      p: [
        "You represent and warrant that you will comply with all applicable laws, including employment, data protection and biometric data laws in your jurisdiction.",
        "You represent and warrant that you are not located in a country that is subject to a U.S. Government embargo or designated as a \"terrorist supporting\" country, and that you are not listed on any U.S. Government list of prohibited or restricted parties.",
      ],
    },
    {
      h: "7. Third-party beneficiary",
      p: [
        "Apple Inc. and its subsidiaries are third-party beneficiaries of this agreement and, upon your acceptance, will have the right to rely upon and enforce this agreement against you as the end user.",
        "The app may include third-party components, and you agree to comply with their applicable terms.",
      ],
    },
    {
      h: "8. U.S. Government users and termination",
      p: [
        "The app is provided as \"Commercial Computer Software\" and \"Commercial Computer Software Documentation\" under FAR 12.212 and DFARS 227.7202, and all rights are granted solely under this agreement.",
        "This licence terminates automatically if you breach any of its terms or when your company's subscription ends, at which point you must delete the app from your devices.",
        "This licence is governed by the laws of the United Kingdom, without prejudice to any mandatory consumer rights in your country of residence.",
      ],
    },
  ],
};
